var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tag-list"},_vm._l((_vm.tagData),function(tag){return _c('tag',{key:tag.id},[_vm._v(" "+_vm._s(tag.name)+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }